export default "__VITE_ASSET__CCn2$4$E__"